
import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import wtyReportApi from "../../services/warrantyReportAxios";
import label_en_US from "./label_en_US";
import {useSelector} from "react-redux";
import {machinesList} from "../machine-search/machineSearchSlice";

const initialState = {
    languageData: label_en_US,
    locale:"en_US",
    loading: false};



export const fetchTranslations = createAsyncThunk(
    "translation/locale",
    async ({ locale }, { rejectWithValue })=> {
        if (!locale) {
            initialState.locale=locale;
            locale = 'en_US';  // Default locale if undefined
        }
        const translationUrl = `/translation/${locale}`;
        try {
            const response = await wtyReportApi.get(translationUrl);
            if (response.status !== 200) {
                new Error("Calling api to get states failed.");
            }
            return await response.data;
        } catch (error) {
            throw error;
        }
    }

)

const translationSlice = createSlice({
    name: 'translations',
    initialState: {
        data: {},
        loading: false,
        error: null
    },
    reducers: {},
    extraReducers: {
        [fetchTranslations.pending]: (state) => {
            state.loading = true;
        },
        [fetchTranslations.fulfilled]: (state, action) => {
            state.loading = false;
            state.data = action.payload;
        },
        [fetchTranslations.rejected]: (state, action) => {
            state.loading = false;
            state.error = action.payload;
        }
    }
});
export const languageResponseData= (state) => state.languageResponse.data;
export const languageResponseError= (state) => state.languageResponse.error;
export const languageResponseLoading= (state) => state.languageResponse.loading;
export const selectedLocale=(state) => state.initialState.locale;

export default translationSlice.reducer;

